import { makeStyles } from "@material-ui/core/styles";

const offlineIndicatorStyles = makeStyles((theme) => ({
	fab: {
		position: "absolute",
		bottom: theme.spacing(2),
		right: theme.spacing(2)
	},
	fabPrimary: {
		color: theme.palette.primary.contrastText,
		backgroundColor: theme.palette.primary.main,
		"&:hover": {
			backgroundColor: theme.palette.primary.main
		}
	}
}));

export default offlineIndicatorStyles;
